import React from 'react';

const LeadTable = ({
  leads,
  loading,
  showFilter,
  columnFilters,
  onColumnFilterChange,
  onSort,
  sortColumn,
  sortDirection,
  onView,
  onEdit,
  onDelete,
}) => {
  const columns = [
    { key: 'View', label: 'View', index: 0, sortable: false },
    { key: 'Edit', label: 'Edit', index: 1, sortable: false },
    { key: 'Delete', label: 'Delete', index: 2, sortable: false },
    { key: 'customer_no', label: 'Contact ID', index: 3, sortable: true },
    { key: 'customer_Name', label: 'Name', index: 4, sortable: true },
    { key: 'maincontactno', label: 'Mobile No', index: 5, sortable: true },
    { key: 'property', label: 'Project', index: 6, sortable: true },
    { key: 'email_id', label: 'Email', index: 7, sortable: true },
    { key: 'status', label: 'Status', index: 8, sortable: true },
    { key: 'remarks', label: 'Remarks', index: 9, sortable: true },
    { key: 'salesPerson', label: 'Sales Person', index: 10, sortable: true },
    { key: 'source', label: 'Source', index: 11, sortable: true },
    { key: 'createdOn', label: 'CreatedOn', index: 12, sortable: true },
  ];

  const SortIcon = ({ column }) => {
    if (column.index !== sortColumn) return <i className="fa fa-sort"></i>;
    return sortDirection === 'asc' ? (
      <i className="fa fa-sort-up"></i>
    ) : (
      <i className="fa fa-sort-down"></i>
    );
  };

  return (
    <div className="table-container" style={{ overflowX: 'auto' }}>
      {loading && <div className="loading-indicator">Loading...</div>}

      <table className="table table-condensed table-bordered table-hover lead-table" style={{ minWidth: '1200px' }}>
        <thead style={{ backgroundColor: '#d3d3d3' }}>
          <tr className="header-row" style={{ backgroundColor: '#d3d3d3' }}>
            {columns.map((col) => (
              <th
                key={col.key}
                className={col.sortable ? 'sortable' : 'no-sort'}
                onClick={() => col.sortable && onSort(col.index)}
                style={{ backgroundColor: '#d3d3d3', color: '#000000', fontWeight: 'bold', cursor: col.sortable ? 'pointer' : 'default', padding: '10px' }}
              >
                <div className="column-header">
                  {col.label}
                  {col.sortable && <SortIcon column={col} />}
                </div>
              </th>
            ))}
          </tr>
          {showFilter && (
            <tr className="filter-row" style={{ backgroundColor: '#f5f5f5' }}>
              {columns.map((col) => (
                <th key={`filter-${col.key}`} style={{ padding: '5px' }}>
                  {col.sortable && (
                    <input
                      type="text"
                      placeholder={`Search ${col.label}`}
                      value={columnFilters[col.index] || ''}
                      onChange={(e) =>
                        onColumnFilterChange(col.index, e.target.value)
                      }
                      className="filter-input"
                      style={{ width: '100%', padding: '5px', backgroundColor: '#e8e8e8', border: '1px solid #ccc' }}
                    />
                  )}
                </th>
              ))}
            </tr>
          )}
        </thead>
        <tbody>
          {leads && leads.length > 0 ? (
            leads.map((lead, idx) => (
              <tr key={`lead-${lead.customer_no}-${idx}`} style={{ backgroundColor: '#ffffff', color: '#800080' }}>
                <td className="action-cell" style={{ textAlign: 'center', padding: '8px' }}>
                  <i 
                    className="fa fa-eye" 
                    onClick={() => onView(lead.customer_no)}
                    title="View"
                    style={{ cursor: 'pointer', color: '#0066cc', fontSize: '16px' }}
                  ></i>
                </td>
                <td className="action-cell" style={{ textAlign: 'center', padding: '8px' }}>
                  <i 
                    className="fa fa-edit" 
                    onClick={() => onEdit(lead.customer_no)}
                    title="Edit"
                    style={{ cursor: 'pointer', color: '#0066cc', fontSize: '16px' }}
                  ></i>
                </td>
                <td className="action-cell" style={{ textAlign: 'center', padding: '8px' }}>
                  <i 
                    className="fa fa-trash-o" 
                    onClick={() => onDelete(lead.customer_no)}
                    title="Delete"
                    style={{ cursor: 'pointer', color: '#cc0000', fontSize: '16px' }}
                  ></i>
                </td>
                <td style={{ padding: '8px', color: '#800080' }}>{lead.customer_no}</td>
                <td style={{ padding: '8px', color: '#800080' }}>{lead.customer_Name}</td>
                <td style={{ padding: '8px', color: '#800080' }}>{lead.maincontactno}</td>
                <td style={{ padding: '8px', color: '#800080' }}>{lead.property}</td>
                <td style={{ padding: '8px', color: '#800080' }}>{lead.email_id}</td>
                <td style={{ padding: '8px', color: '#800080' }}>{lead.status}</td>
                <td style={{ padding: '8px', color: '#800080' }}>{lead.remarks}</td>
                <td style={{ padding: '8px', color: '#800080' }}>{lead.salesPerson}</td>
                <td style={{ padding: '8px', color: '#800080' }}>{lead.source}</td>
                <td style={{ padding: '8px', color: '#800080' }}>{lead.createdOn}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} className="text-center no-data" style={{ padding: '20px' }}>
                {loading ? 'Loading...' : 'No data available'}
              </td>
            </tr>
          )}
        </tbody>
        <tfoot>
          <tr className="footer-row">
            {columns.map((col) => (
              <th key={`footer-${col.key}`}>-</th>
            ))}
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default LeadTable;
